(function() {
  'use strict';

  function PriceSimulatorCtrl ($uibModal, Auth) {
    var ctrl = this;
    ctrl.showSimulator = function () {
      $uibModal.open({
        animation: false,
        backdrop: true,
        windowClass: 'ps-modal',
        template: require('./modal/modal.html'),
        controller: 'ModalCtrl',
        controllerAs: '$ctrl',
        resolve: {
          order: function() {
            return {
              zipCode: ctrl.zipCode.replace(/-/,''),
              userProfile: Auth.isPJ(),
            };
          }
        }
      });
    };
  }

  angular
    .module('mandaeApp')
    .controller('PriceSimulatorCtrl', PriceSimulatorCtrl);
}());
